import axios from 'axios'
import { API_URL } from '../../../config'
import { storage } from '../../../helpers'
import { MESSAGE } from '../../../constants'

export const getSupportingDocuments = async (documentId) => {
  try {
    const token = storage.getToken()
    const response = await axios.get(
      `${API_URL}/documents/${documentId}/supporting-documents`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    )
    return response.data
  } catch (error) {
    console.error(MESSAGE.SUPPORTING_DOCUMENTS_ERRORS.get, error)
    throw error
  }
}

export const uploadSupportingDocument = async (documentId, formData) => {
  try {
    const token = storage.getToken()
    const response = await axios.put(
      `${API_URL}/documents/${documentId}/supporting-documents`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`
        }
      }
    )
    return response.data
  } catch (error) {
    console.error(MESSAGE.SUPPORTING_DOCUMENTS_ERRORS.upload, error)
    throw error
  }
}

export const deleteSupportingDocument = async (documentId, downloadId) => {
  try {
    const token = storage.getToken()
    const response = await axios.delete(
      `${API_URL}/documents/${documentId}/supporting-documents/${downloadId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    )
  } catch (error) {
    console.error(MESSAGE.SUPPORTING_DOCUMENTS_ERRORS.delete, error)
    throw error
  }
}

export const bulkDeleteSupportingDocument = async (documentId) => {
  try {
    const token = storage.getToken()
    const response = await axios.delete(
      `${API_URL}/documents/${documentId}/supporting-documents`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    )
  } catch (error) {
    console.error(MESSAGE.SUPPORTING_DOCUMENTS_ERRORS.delete, error)
    throw error
  }
}

export const bulkDownloadSupportingDocument = async (documentId) => {
  try {
    const token = storage.getToken()
    const response = await axios.post(
      `${API_URL}/documents/${documentId}/supporting-documents`,
      {},
      {
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    )

    const url = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', `supporting_documents_${documentId}.zip`)
    document.body.appendChild(link)
    link.click()
    link.parentNode.removeChild(link)
  } catch (error) {
    console.error(MESSAGE.SUPPORTING_DOCUMENTS_ERRORS.downloadDocuments, error)
    throw error
  }
}

export const downloadSupportingDocument = async (
  documentId,
  downloadId,
  fileName
) => {
  try {
    const token = storage.getToken()
    const response = await axios.get(
      `${API_URL}/documents/${documentId}/supporting-documents/${downloadId}?dispositionType=attachment`,
      {
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    )

    const url = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', fileName)
    document.body.appendChild(link)
    link.click()
    link.parentNode.removeChild(link)
  } catch (error) {
    console.error(MESSAGE.SUPPORTING_DOCUMENTS_ERRORS.downloadDocuments, error)
    throw error
  }
}

export const viewSupportingDocument = async (documentId, downloadId) => {
  try {
    const token = storage.getToken()
    const response = await axios.get(
      `${API_URL}/documents/${documentId}/supporting-documents/${downloadId}?dispositionType=inline`,
      {
        responseType: 'blob',
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    )

    const fileBlob = new Blob([response.data], { type: response.data.type })
    const fileUrl = URL.createObjectURL(fileBlob)

    return fileUrl;
  } catch (error) {
    console.error(MESSAGE.SUPPORTING_DOCUMENTS_ERRORS.downloadDocuments, error)
    throw error
  }
}
